/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateGpsIntegrationCommand,
  CreateGpsIntegrationCommandResponse,
  GetGpsIntegrationsParams,
  GpsIntegrationsQueryData,
  GpsIntegrationsQueryResponse,
  UpdateGpsIntegrationBody,
  UpdateGpsIntegrationCommandResponse,
  UpdateGpsIntegrationPriorityBody
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGpsIntegrations = (
    params: GetGpsIntegrationsParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<GpsIntegrationsQueryResponse>(
      {url: `/api/v1/gps-integrations`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetGpsIntegrationsQueryKey = (params: GetGpsIntegrationsParams,) => {
    return [`/api/v1/gps-integrations`, ...(params ? [params]: [])] as const;
    }

    
export const getGetGpsIntegrationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getGpsIntegrations>>, GetGpsIntegrationsParams['page']>, TError = ErrorType<unknown>>(params: GetGpsIntegrationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData, Awaited<ReturnType<typeof getGpsIntegrations>>, QueryKey, GetGpsIntegrationsParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGpsIntegrationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGpsIntegrations>>, QueryKey, GetGpsIntegrationsParams['page']> = ({ signal, pageParam }) => getGpsIntegrations({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData, Awaited<ReturnType<typeof getGpsIntegrations>>, QueryKey, GetGpsIntegrationsParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetGpsIntegrationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getGpsIntegrations>>>
export type GetGpsIntegrationsInfiniteQueryError = ErrorType<unknown>


export function useGetGpsIntegrationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGpsIntegrations>>, GetGpsIntegrationsParams['page']>, TError = ErrorType<unknown>>(
 params: GetGpsIntegrationsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData, Awaited<ReturnType<typeof getGpsIntegrations>>, QueryKey, GetGpsIntegrationsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGpsIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getGpsIntegrations>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGpsIntegrationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGpsIntegrations>>, GetGpsIntegrationsParams['page']>, TError = ErrorType<unknown>>(
 params: GetGpsIntegrationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData, Awaited<ReturnType<typeof getGpsIntegrations>>, QueryKey, GetGpsIntegrationsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGpsIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getGpsIntegrations>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGpsIntegrationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGpsIntegrations>>, GetGpsIntegrationsParams['page']>, TError = ErrorType<unknown>>(
 params: GetGpsIntegrationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData, Awaited<ReturnType<typeof getGpsIntegrations>>, QueryKey, GetGpsIntegrationsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetGpsIntegrationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGpsIntegrations>>, GetGpsIntegrationsParams['page']>, TError = ErrorType<unknown>>(
 params: GetGpsIntegrationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData, Awaited<ReturnType<typeof getGpsIntegrations>>, QueryKey, GetGpsIntegrationsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetGpsIntegrationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetGpsIntegrationsQueryOptions = <TData = Awaited<ReturnType<typeof getGpsIntegrations>>, TError = ErrorType<unknown>>(params: GetGpsIntegrationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGpsIntegrationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGpsIntegrations>>> = ({ signal }) => getGpsIntegrations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetGpsIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof getGpsIntegrations>>>
export type GetGpsIntegrationsQueryError = ErrorType<unknown>


export function useGetGpsIntegrations<TData = Awaited<ReturnType<typeof getGpsIntegrations>>, TError = ErrorType<unknown>>(
 params: GetGpsIntegrationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGpsIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getGpsIntegrations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGpsIntegrations<TData = Awaited<ReturnType<typeof getGpsIntegrations>>, TError = ErrorType<unknown>>(
 params: GetGpsIntegrationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGpsIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getGpsIntegrations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGpsIntegrations<TData = Awaited<ReturnType<typeof getGpsIntegrations>>, TError = ErrorType<unknown>>(
 params: GetGpsIntegrationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetGpsIntegrations<TData = Awaited<ReturnType<typeof getGpsIntegrations>>, TError = ErrorType<unknown>>(
 params: GetGpsIntegrationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetGpsIntegrationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetGpsIntegrationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getGpsIntegrations>>, TError = ErrorType<unknown>>(params: GetGpsIntegrationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGpsIntegrationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGpsIntegrations>>> = ({ signal }) => getGpsIntegrations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetGpsIntegrationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getGpsIntegrations>>>
export type GetGpsIntegrationsSuspenseQueryError = ErrorType<unknown>


export function useGetGpsIntegrationsSuspense<TData = Awaited<ReturnType<typeof getGpsIntegrations>>, TError = ErrorType<unknown>>(
 params: GetGpsIntegrationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGpsIntegrationsSuspense<TData = Awaited<ReturnType<typeof getGpsIntegrations>>, TError = ErrorType<unknown>>(
 params: GetGpsIntegrationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGpsIntegrationsSuspense<TData = Awaited<ReturnType<typeof getGpsIntegrations>>, TError = ErrorType<unknown>>(
 params: GetGpsIntegrationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetGpsIntegrationsSuspense<TData = Awaited<ReturnType<typeof getGpsIntegrations>>, TError = ErrorType<unknown>>(
 params: GetGpsIntegrationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGpsIntegrations>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetGpsIntegrationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createGpsIntegration = (
    createGpsIntegrationCommand: BodyType<CreateGpsIntegrationCommand>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CreateGpsIntegrationCommandResponse>(
      {url: `/api/v1/gps-integrations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGpsIntegrationCommand, signal
    },
      options);
    }
  


export const getCreateGpsIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGpsIntegration>>, TError,{data: BodyType<CreateGpsIntegrationCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof createGpsIntegration>>, TError,{data: BodyType<CreateGpsIntegrationCommand>}, TContext> => {
    
const mutationKey = ['createGpsIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGpsIntegration>>, {data: BodyType<CreateGpsIntegrationCommand>}> = (props) => {
          const {data} = props ?? {};

          return  createGpsIntegration(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateGpsIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof createGpsIntegration>>>
    export type CreateGpsIntegrationMutationBody = BodyType<CreateGpsIntegrationCommand>
    export type CreateGpsIntegrationMutationError = ErrorType<unknown>

    export const useCreateGpsIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGpsIntegration>>, TError,{data: BodyType<CreateGpsIntegrationCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createGpsIntegration>>,
        TError,
        {data: BodyType<CreateGpsIntegrationCommand>},
        TContext
      > => {

      const mutationOptions = getCreateGpsIntegrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getGpsIntegration = (
    id: number,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<GpsIntegrationsQueryData>(
      {url: `/api/v1/gps-integrations/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetGpsIntegrationQueryKey = (id: number,) => {
    return [`/api/v1/gps-integrations/${id}`] as const;
    }

    
export const getGetGpsIntegrationInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getGpsIntegration>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGpsIntegrationQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGpsIntegration>>> = ({ signal }) => getGpsIntegration(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetGpsIntegrationInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getGpsIntegration>>>
export type GetGpsIntegrationInfiniteQueryError = ErrorType<unknown>


export function useGetGpsIntegrationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGpsIntegration>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGpsIntegration>>,
          TError,
          Awaited<ReturnType<typeof getGpsIntegration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGpsIntegrationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGpsIntegration>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGpsIntegration>>,
          TError,
          Awaited<ReturnType<typeof getGpsIntegration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGpsIntegrationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGpsIntegration>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetGpsIntegrationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGpsIntegration>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetGpsIntegrationInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetGpsIntegrationQueryOptions = <TData = Awaited<ReturnType<typeof getGpsIntegration>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGpsIntegrationQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGpsIntegration>>> = ({ signal }) => getGpsIntegration(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetGpsIntegrationQueryResult = NonNullable<Awaited<ReturnType<typeof getGpsIntegration>>>
export type GetGpsIntegrationQueryError = ErrorType<unknown>


export function useGetGpsIntegration<TData = Awaited<ReturnType<typeof getGpsIntegration>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGpsIntegration>>,
          TError,
          Awaited<ReturnType<typeof getGpsIntegration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGpsIntegration<TData = Awaited<ReturnType<typeof getGpsIntegration>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGpsIntegration>>,
          TError,
          Awaited<ReturnType<typeof getGpsIntegration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGpsIntegration<TData = Awaited<ReturnType<typeof getGpsIntegration>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetGpsIntegration<TData = Awaited<ReturnType<typeof getGpsIntegration>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetGpsIntegrationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetGpsIntegrationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getGpsIntegration>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGpsIntegrationQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGpsIntegration>>> = ({ signal }) => getGpsIntegration(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetGpsIntegrationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getGpsIntegration>>>
export type GetGpsIntegrationSuspenseQueryError = ErrorType<unknown>


export function useGetGpsIntegrationSuspense<TData = Awaited<ReturnType<typeof getGpsIntegration>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGpsIntegrationSuspense<TData = Awaited<ReturnType<typeof getGpsIntegration>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGpsIntegrationSuspense<TData = Awaited<ReturnType<typeof getGpsIntegration>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetGpsIntegrationSuspense<TData = Awaited<ReturnType<typeof getGpsIntegration>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getGpsIntegration>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetGpsIntegrationSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateGpsIntegration = (
    id: number,
    updateGpsIntegrationBody: BodyType<UpdateGpsIntegrationBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<UpdateGpsIntegrationCommandResponse>(
      {url: `/api/v1/gps-integrations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateGpsIntegrationBody
    },
      options);
    }
  


export const getUpdateGpsIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGpsIntegration>>, TError,{id: number;data: BodyType<UpdateGpsIntegrationBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGpsIntegration>>, TError,{id: number;data: BodyType<UpdateGpsIntegrationBody>}, TContext> => {
    
const mutationKey = ['updateGpsIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGpsIntegration>>, {id: number;data: BodyType<UpdateGpsIntegrationBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateGpsIntegration(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGpsIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof updateGpsIntegration>>>
    export type UpdateGpsIntegrationMutationBody = BodyType<UpdateGpsIntegrationBody>
    export type UpdateGpsIntegrationMutationError = ErrorType<unknown>

    export const useUpdateGpsIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGpsIntegration>>, TError,{id: number;data: BodyType<UpdateGpsIntegrationBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateGpsIntegration>>,
        TError,
        {id: number;data: BodyType<UpdateGpsIntegrationBody>},
        TContext
      > => {

      const mutationOptions = getUpdateGpsIntegrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteGpsIntegration = (
    id: number,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/gps-integrations/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteGpsIntegrationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGpsIntegration>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGpsIntegration>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['deleteGpsIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGpsIntegration>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteGpsIntegration(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteGpsIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGpsIntegration>>>
    
    export type DeleteGpsIntegrationMutationError = ErrorType<unknown>

    export const useDeleteGpsIntegration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGpsIntegration>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteGpsIntegration>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteGpsIntegrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const updateGpsIntegrationPriority = (
    id: number,
    updateGpsIntegrationPriorityBody: BodyType<UpdateGpsIntegrationPriorityBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/gps-integrations/${id}/priority`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateGpsIntegrationPriorityBody
    },
      options);
    }
  


export const getUpdateGpsIntegrationPriorityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGpsIntegrationPriority>>, TError,{id: number;data: BodyType<UpdateGpsIntegrationPriorityBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGpsIntegrationPriority>>, TError,{id: number;data: BodyType<UpdateGpsIntegrationPriorityBody>}, TContext> => {
    
const mutationKey = ['updateGpsIntegrationPriority'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGpsIntegrationPriority>>, {id: number;data: BodyType<UpdateGpsIntegrationPriorityBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateGpsIntegrationPriority(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGpsIntegrationPriorityMutationResult = NonNullable<Awaited<ReturnType<typeof updateGpsIntegrationPriority>>>
    export type UpdateGpsIntegrationPriorityMutationBody = BodyType<UpdateGpsIntegrationPriorityBody>
    export type UpdateGpsIntegrationPriorityMutationError = ErrorType<unknown>

    export const useUpdateGpsIntegrationPriority = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGpsIntegrationPriority>>, TError,{id: number;data: BodyType<UpdateGpsIntegrationPriorityBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateGpsIntegrationPriority>>,
        TError,
        {id: number;data: BodyType<UpdateGpsIntegrationPriorityBody>},
        TContext
      > => {

      const mutationOptions = getUpdateGpsIntegrationPriorityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    